// tslint:disable:no-any

import React, { Component } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import Message from '../components/Message';

export interface IDiveShareModalProps {
    display: any;
    shareTokenId: any;
    hideModal: () => void;
}

interface IDiveShareModalState {
    shareTokenId: any;
    display: any;
    url: string;
    messages: any;
}

export default class DiveShareModal extends Component<
    IDiveShareModalProps,
    IDiveShareModalState
> {
    constructor(props: IDiveShareModalProps) {
        super(props);

        this.state = {
            display: props.display,
            shareTokenId: props.shareTokenId,
            url: '',
            messages: []
        };
    }

    componentWillReceiveProps(nextProps: IDiveShareModalProps) {
        this.setState(
            {
                display: nextProps.display,
                shareTokenId: nextProps.shareTokenId
            },
            () => {
                this.setState({
                    url:
                        window.location.origin +
                        '/app/add-shared-dive/' +
                        this.state.shareTokenId
                });
            }
        );
    }

    hideModal() {
        this.props.hideModal();
    }

    onClickClose(e: Event) {
        this.hideModal();
        e.preventDefault();
    }

    onMessageClose() {
        this.setState({
            messages: []
        });
    }

    onCopied() {
        var newMessages = [];
        newMessages.push({
            text: 'Copied!',
            type: 'success',
            autoClose: true
        });
        this.setState({
            messages: newMessages
        });
    }

    render() {
        return (
            <div
                className={
                    'modalOverlay' + (this.state.display ? '' : ' hidden')
                }
            >
                <div className="modalSlide">
                    <div className="modal shareDive">
                        <button
                            className="close"
                            onClick={e => this.onClickClose(e as any)}
                        />
                        <div className="modal-header">
                            <h3>Share Dive</h3>
                        </div>
                        <div className="modal-content text-left cf">
                            <p>
                                We decided to simplify dive sharing
                                significantly. You don't need to designate
                                someone as your friend to share a dive with them
                                anymore!<br />
                                <br />
                                Just copy this link and share it.
                            </p>

                            {this.state.messages.length > 0 && (
                                <div className="messages">
                                    {this.state.messages.map(
                                        (message: any, index: number) => {
                                            return (
                                                <Message
                                                    key={index}
                                                    type={message.type}
                                                    text={message.text}
                                                    autoClose={
                                                        message.autoClose
                                                    }
                                                    onClose={() =>
                                                        this.onMessageClose()
                                                    }
                                                />
                                            );
                                        }
                                    )}
                                </div>
                            )}

                            <input
                                type="text"
                                name="url"
                                value={this.state.url}
                                disabled={true}
                            />
                            <CopyToClipboard
                                text={this.state.url}
                                onCopy={() => this.onCopied()}
                            >
                                <button className="btn btn--xsmallpill btn--backroundRed copy-to-clipboard">
                                    Copy
                                </button>
                            </CopyToClipboard>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn--xsmallpill btn--borderRed btn--colorRed"
                                onClick={e => this.onClickClose(e as any)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveShareModal.tsx